import {
  ITutorialDto,
  TutorialJourneyType,
} from "@growth-machine-llc/stridist-api-client";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { FC, useState } from "react";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    width: "450px",
    maxWidth: "90%",
  },

  fullWidthButton: {
    width: "100%",
    justifyContent: "center",
    padding: theme.spacing(1.5),
    fontSize: 16,
  },
}));

interface JourneyDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (title: string, type: number, description?: string) => void;
  isPending?: boolean;
  tutorialJourneys?: ITutorialDto[];
}

export const JourneyDialog: FC<JourneyDialogProps> = ({
  open,
  onClose,
  onSave,
  isPending = false,
  tutorialJourneys = [],
}) => {
  const s = useStyles();
  const [title, setTitle] = useState("");
  const [journeyType, setJourneyType] = useState<"" | number>("");
  const [description, setDescription] = useState<string>("");

  const existingTypes = tutorialJourneys.map((j) => j.type);

  const handleSave = () => {
    if (title.trim() && journeyType !== "") {
      onSave(title, journeyType as number, description.trim() || undefined);
      setTitle("");
      setJourneyType("");
      setDescription("");
      handleClose();
    }
  };

  const handleClose = () => {
    setTitle("");
    setJourneyType("");
    setDescription("");
    onClose();
  };

  const availableTypes = Object.entries(TutorialJourneyType).filter(
    ([, value]) => typeof value === "string" && !existingTypes.includes(value),
  );

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      classes={{ paper: s.dialogPaper }}
    >
      <DialogTitle>Create New Template</DialogTitle>

      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Title"
          fullWidth
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />

        <TextField
          margin="dense"
          label="Description (optional)"
          fullWidth
          multiline
          minRows={2}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel id="journey-type-label">Type</InputLabel>
          <Select
            labelId="journey-type-label"
            value={journeyType}
            label="Type"
            onChange={(e) => setJourneyType(e.target.value as number)}
          >
            {availableTypes.length > 0 ? (
              availableTypes.map(([key, value]) => (
                <MenuItem key={value} value={value}>
                  {key}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>No types available</MenuItem>
            )}
          </Select>
        </FormControl>
      </DialogContent>

      <DialogActions sx={{ p: 2, justifyContent: "center" }}>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={!title.trim() || journeyType === "" || isPending}
          className={s.fullWidthButton}
        >
          Create Template
        </Button>
      </DialogActions>
    </Dialog>
  );
};
